import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "p-d-flex p-flex-column p-jc-center p-align-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "The url is malformed", -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResetPassword = _resolveComponent("ResetPassword")!
  const _component_EmailVerification = _resolveComponent("EmailVerification")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.state.opType === 'resetPassword' && !$setup.state.malformedUrl)
      ? (_openBlock(), _createBlock(_component_ResetPassword, {
          key: 0,
          "action-code": $setup.state.actionCode
        }, null, 8 /* PROPS */, ["action-code"]))
      : ($setup.state.opType === 'verifyEmail' && !$setup.state.malformedUrl)
        ? (_openBlock(), _createBlock(_component_EmailVerification, {
            key: 1,
            "next-url": $setup.state.nextUrl,
            "action-code": $setup.state.actionCode
          }, null, 8 /* PROPS */, ["next-url", "action-code"]))
        : _createCommentVNode("v-if", true),
    ($setup.state.malformedUrl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}